import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '@shared/ui/badges'
import type { TasksKanbanCardProps } from '../types/interfaces'

import { TaskPriority } from '@entities/task'

interface TasksKanbanCardOptions {
  props: TasksKanbanCardProps
  onClick: (taskId: number) => void
}

interface TasksKanbanCardReturn {
  refShowPriority: ComputedRef<boolean>
  refPriorityColor: ComputedRef<AppBadgeColor>
  handleClick: () => void
}

const PRIORITY_COLORS: Partial<Record<TaskPriority, AppBadgeColor>> = {
  [TaskPriority.Urgent]: 'red',
  [TaskPriority.High]: 'orange',
  [TaskPriority.Medium]: 'amber',
  [TaskPriority.Low]: 'blue',
}

export const useTasksKanbanCard = ({ props, onClick }: TasksKanbanCardOptions): TasksKanbanCardReturn => {
  const refShowPriority = computed<boolean>(() =>
    !!props.priority && props.priority !== TaskPriority.NoPriority,
  )

  const refPriorityColor = computed<AppBadgeColor>(() =>
    (props.priority && PRIORITY_COLORS[props.priority]) || 'slate',
  )

  const handleClick = (): void => {
    onClick(props.taskId)
  }

  return {
    refShowPriority,
    refPriorityColor,
    handleClick,
  }
}
